import * as React from 'react';

export const PauseIcon = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="41" cy="41" r="28" fill="#E4FBFF" />
      <circle cx="36" cy="36" r="28" stroke="#0099C7" strokeWidth="2" />
      <rect
        x="28"
        y="24"
        width="5"
        height="24"
        rx="1"
        stroke="#0099C7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="39"
        y="24"
        width="5"
        height="24"
        rx="1"
        stroke="#0099C7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
